// eslint-disable-next-line @typescript-eslint/triple-slash-reference, spaced-comment
/// <reference types="@ps/web-spade-sdk/types" />
import type { InitSchema } from '@ps/web-spade-types';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { select } from '../../';

export const useSpadeSdk = () => {
  const locale = useSelector(select.locale.get) as InitSchema['locale'];

  const spadeSdk = useRef(window.Spade?.init({ locale }));

  return spadeSdk.current;
};
